import BinaryTree from "./binaryTree.js";
import {RangeSetBuilder} from "@codemirror/state";

export default class BinaryTreeRangeSetBuilder {
  constructor() {
    this.tree = new BinaryTree();
  }

  add(from, to, decoration) {
    this.tree.insert(from, {from, to, decoration});
  }

  finish() {
    const builder = new RangeSetBuilder();
    this.tree.forEach(({from, to, decoration}) => builder.add(from, to, decoration));
    return builder.finish();
  }
}
